export default __webpack_public_path__ + "static/media/3D.b9aa780c.svg";